import { environment } from "src/environments/environment.prod";

//local server
 //   const apiUrlBase = environment.production ? 'http://localhost:59985'  : 'http://localhost:59985' ;
//pdx3 server

//const apiUrlBase = environment.production ? 'http://pdx3.mimics.us:9012'  : 'http://pdx3.mimics.us:9012' ; //pdx3 sever


// Live Server
 const apiUrlBase = environment.production ? 'https://submissions.centralbankbahamas.com:9000/BGRSApplication' : 'https://submissions.centralbankbahamas.com:9000/BGRSApplication';


//Test Server

// const apiUrlBase = environment.production ? 'https://submissions.centralbankbahamas.com:9000/BGRSApplicationTEST' : 'https://submissions.centralbankbahamas.com:9000/BGRSApplicationTEST'; // For Test Server

//new cbbs webserver test

//const apiUrlBase = environment.production ? 'http://10.22.66.17:8000/BGRS' : 'http://10.22.66.17:8000/BGRS'; // For new  Test Server

  //const apiUrlBase = environment.production ? 'https://www.wildsoft.in/BRS_Web_Backend'  : 'https://www.wildsoft.in/BRS_Web_Backend' ;


const CONFIG = {
    environment: 'full',
    loginApiUrlBase: `${apiUrlBase}/api/login`,
    enrollApiUrlBase: `${apiUrlBase}/api/save`,
    accountApiUrlBase: `${apiUrlBase}/api/account`,
    getbankIdDropdownApiUrlBase: `${apiUrlBase}/api/getbankId`,
    applicationApiUrlBase: `${apiUrlBase}/api/pageload`,
    applicationfilterbenApiUrlBase: `${apiUrlBase}/api/filterbendata`,
    viewApiUrlBase: `${apiUrlBase}/api/view`,
    sendemailApiUrlBase: `${apiUrlBase}/api/ForgotPassword`,
    usersApiUrlBase: `${apiUrlBase}/api/user`,
    changePasswordApiUrlBase: `${apiUrlBase}/api/changePassword`,
    unsubsribeApiUrlBase: `${apiUrlBase}/api/unsubsribepageload`,
};
export default CONFIG;